import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { $UserDetailV2 } from 'shared/atoms';
import { $SEOCurrentTraffic } from 'shared/atoms/common/traffic';
import { EPageType, IUserDetail, UserDetailUtil } from 'shared/models';
import { IUserCurrentTraffic } from 'shared/models/#common/current-traffic';

export const CurrentUserId = atom((get) => {
  const traffic = get($SEOCurrentTraffic);
  const { pageType } = traffic;

  if (![EPageType.user, EPageType.user_follow, EPageType.user_topic].includes(pageType)) {
    return Unreachable(`invalid pageType: ${pageType}`);
  }

  const userTraffic = traffic as IUserCurrentTraffic;

  return userTraffic.userId || null;
});

export const $CurrentUserLinkName = atom((get) => {
  const traffic = get($SEOCurrentTraffic);
  const { pageType } = traffic;

  if (![EPageType.user, EPageType.user_follow, EPageType.user_topic].includes(pageType)) {
    return Unreachable(`invalid pageType: ${pageType}`);
  }

  const userTraffic = traffic as IUserCurrentTraffic;

  return userTraffic.userLinkName;
});

export const $CurrentUser = atom((get) => {
  const currentUserLinkName = get($CurrentUserLinkName);
  return get($UserDetailV2(currentUserLinkName));
});

export const $CurrentAvailableUserOrNull = atom(async (get) => {
  const user = await get($CurrentUser);
  return UserDetailUtil.isUserAvailable(user) ? user : null;
});

export const $CurrentUserAsAvailable = atom(async (get) => {
  const user = await get($CurrentUser);
  return user as IUserDetail;
});
